import ApiClient from '../shared/ApiCliente';

export interface AtualizarDadosBasicosUsuarioRequest {
  cpf?: string;
  name?: string;
  phoneNumber?: string;
}

export const userProfileService = {
  atualizarDadosBasicos: async (
    payload: AtualizarDadosBasicosUsuarioRequest
  ): Promise<void> => {
    await ApiClient.put('/usuario/dados-basicos', payload);
  },
};


